exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3uikvoKIzIutINPV1aEp59{padding-left:1.42857rem;padding-right:1.42857rem;background-color:#f3f5f7;border-bottom:.07143rem solid #ccc;padding-left:.35714rem}@media only screen and (min-width:640px){._3uikvoKIzIutINPV1aEp59{padding-left:2.14286rem;padding-right:2.14286rem;padding-left:1.07143rem}}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudentInfoBar": "_3uikvoKIzIutINPV1aEp59"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Student/StudentInfoBar/style.postcss
// module id = 2093
// module chunks = 0